import React from "react";
import { useFilters } from "./FilterContext";

function Loader() {
  const { loader } = useFilters();
  return (
    <>
      {loader && (
        // <div className="loader-wrapper">
        //   <div className="loading"></div>
        // </div>
        <></>
      )}
    </>
  );
}

export default Loader;
